import { ApiConfig } from "@eng-dx-gpt/api-client";

/**
 * Knowledge Base microservice API configuration
 * All endpoints related to file management, knowledge bases, connectors, and chunking strategies
 */
export const knowledgeBaseBackendConfig: ApiConfig[] = [
    // File Controller
    {
        name: "getFileById",
        method: "GET",
        url: "/file/{id}",
        service: "kb",
    },
    {
        name: "putFileById",
        method: "PUT",
        url: "/file/{id}",
        service: "kb",
    },
    {
        name: "deleteFileById",
        method: "DELETE",
        url: "/file/{id}",
        service: "kb",
    },
    {
        name: "patchFileById",
        method: "PATCH",
        url: "/file/{id}",
        service: "kb",
    },
    {
        name: "getFile",
        method: "GET",
        url: "/file",
        service: "kb",
    },
    {
        name: "postFile",
        method: "POST",
        url: "/file",
        service: "kb",
    },
    {
        name: "getUrl",
        method: "GET",
        url: "/url",
        service: "kb",
    },
    {
        name: "postUrl",
        method: "POST",
        url: "/url/bulk",
        service: "kb",
    },
    {
        name: "deleteUrls",
        method: "DELETE",
        url: "/url",
        service: "kb",
    },
    {
        name: "deleteUrlById",
        method: "DELETE",
        url: "/url/{id}",
        service: "kb",
    },
    {
        name: "getKnowledgeBaseByIdDatapointsUrls",
        method: "GET",
        url: "/knowledge-base/{kbId}/datapoints/urls/{urlId}",
        service: "kb",
    },
    {
        name: "refreshUrlsByKnowledgeBaseId",
        method: "POST",
        url: "/knowledge-base/{kbId}/urls/refresh",
        service: "kb",
    },
    {
        name: "deleteFile",
        method: "DELETE",
        url: "/file",
        service: "kb",
    },
    {
        name: "getFileDownloadById",
        method: "GET",
        url: "/file/download/{id}",
        service: "kb",
    },

    // Connector Controller
    {
        name: "getConnectors",
        method: "GET",
        url: "/connector",
        service: "kb",
    },
    {
        name: "getConnectorById",
        method: "GET",
        url: "/connector/{id}",
        service: "kb",
    },
    {
        name: "getExternalUrls",
        method: "GET",
        url: "/connector/{connectorId}/options/{optionId}/external-data",
        service: "kb",
    },

    // Knowledge Base Controller
    {
        name: "getKnowledgeBaseById",
        method: "GET",
        url: "/knowledge-base/{id}",
        service: "kb",
    },
    {
        name: "putKnowledgeBaseById",
        method: "PUT",
        url: "/knowledge-base/{id}",
        service: "kb",
    },
    {
        name: "deleteKnowledgeBaseById",
        method: "DELETE",
        url: "/knowledge-base/{id}",
        service: "kb",
    },
    {
        name: "getKnowledgeBase",
        method: "GET",
        url: "/knowledge-base",
        service: "kb",
    },
    {
        name: "postKnowledgeBase",
        method: "POST",
        url: "/knowledge-base",
        service: "kb",
    },
    {
        name: "deleteKnowledgeBase",
        method: "DELETE",
        url: "/knowledge-base",
        service: "kb",
    },
    {
        name: "getKnowledgeBaseByIdStatus",
        method: "GET",
        url: "/knowledge-base/{id}/status/{status}",
        service: "kb",
    },
    {
        name: "getKnowledgeBaseByIdDatapoints",
        method: "GET",
        url: "/knowledge-base/{kbId}/datapoints/files/{fileId}",
        service: "kb",
    },
    {
        name: "getKnowledgeBaseByIdDatapoints",
        method: "GET",
        url: "/knowledge-base/{id}/datapoints",
        service: "kb",
    },
    {
        name: "deleteKnowledgeBaseByIdFiles",
        method: "DELETE",
        url: "/knowledge-base/{id}/files",
        service: "kb",
    },

    // Strategy & Metadata
    {
        name: "getListStrategyChunks",
        method: "GET",
        url: "/strategy",
        service: "kb",
    },
    {
        name: "getListTopics",
        method: "GET",
        url: "/tag",
        service: "kb",
    },
    {
        name: "getListSources",
        method: "GET",
        url: "/list-sources",
        service: "kb",
    },
    {
        name: "getListTargets",
        method: "GET",
        url: "/list-targets",
        service: "kb",
    },
];
